<template>
  <div>
    <custom-actions>
      <el-form :model="searchForm" inline ref="searchForm" class="global-form-label-width">

        <el-form-item label="品种规格" prop="specName">
          <el-input v-model="searchForm.specName" placeholder="请输入品种规格"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="160" label="订单ID" prop="orderId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="160" label="提货ID" prop="deliveryId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="规格单位" prop="specXh"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="计划提货数量" prop="deliveryPlan"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="实际提货数量" prop="deliveryQty"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="司机身份证" prop="driverKey"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="司机手机号" prop="driverMobile"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="160" label="提货库点" prop="vehicleStartAddress"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="160" label="卸货库点" prop="vehicleEndAddress"></el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'OrderPoundBill',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        specName: null
      }
    }
  },
  computed: {

  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.purchaseOrders.selectYcnDeliverySpecByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
